













import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";
import { User } from "front-component/modules/User";
import Page from "@/components/Page.vue";
import Header from "@/components/Header.vue";
import FlashMessage from "@/components/FlashMessage";

const components = {
    Page,
    Header,
    FlashMessage,
};

@Component({ components })
export default class App extends Vue {
    @Getter("getCurrentUser") public currentUser!: User|null;
    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;

    @Action("loadOwners") protected loadOwners!: () => Promise<void>;
    @Action("loadMasterOwners") protected loadMasterOwners!: () => Promise<void>;
    @Action("loadTopics") protected loadTopics!: () => Promise<void>;
    @Action("loadBudgets") protected loadBudgets!: () => void;
    @Action("loadAllocationTypes") protected loadAllocationTypes!: () => void;
    @Action("loadBudgetAllocations") protected loadBudgetAllocations!: (ownerUuid: string) => void;
    @Action("loadTitles") protected loadTitles!: () => void;
    @Action("loadTypes") protected loadTypes!: () => void;
    @Action("loadGroupCommitments") protected loadGroupCommitments!: () => void;
    @Action("loadRequesters") protected loadRequesters!: (ownerUuid: string) => void;
    @Action("loadAssignedUsers") protected loadAssignedUsers!: (ownerUuid: string) => void;
    @Action("loadFeatures") protected loadFeatures!: () => void;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    protected mounted(): void {
        this.fetchData();
    }

    @Watch("currentUser") protected changedUser(): void {
        this.fetchData();
    }

    protected fetchData(): void {
        if (null === this.currentUser) {
            return;
        }
        this.loadOwners();
    }

    private get loading(): boolean {
        return this.$store.state.translation.translations.length === 0;
    }
}
